import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'designsystem',
    loadChildren: () =>
      import('./designsystem-nds/designsystem-nds.module').then(
        (m) => m.DesignsystemNdsModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./process-designer/process-designer.module').then(
        (m) => m.ProcessDesignerModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
